import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";

import { UPDATE_GROUP } from "../group.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateGroupInput } from "../../../__generated__/globalTypes";
import {
  UpdateGroupMutation,
  UpdateGroupMutationVariables,
} from "../../../__generated__/UpdateGroupMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateGroup = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateGroupInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateGroupMutation,
    UpdateGroupMutationVariables
  >(UPDATE_GROUP, {
    refetchQueries: ["GroupsQuery", "GroupQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateGroup?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateGroup?.error ?? "Error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
